import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Costcenters} from './costcenters';
import {TreeNode} from "primeng/api";

@Injectable()
export class CostcentersService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('costcenters?' + params.toString()).map((response: Response) => response.json());
  }
  getAllGroups(_type : number = 0) {
      return this.http.get('costcenters/lastcostcenters/' + _type).map((response: Response) => response.json());
  }

  getAllCostcenters() {
    return this.http.get('costcenters/all').map((response: Response) => response.json());
  }
  getFullCostcenters() {
    return this.http.get('costcenters/full').map((response: Response) => response.json());
  }

  getAllGroups_exept(_id: string) {
    return this.http.get('costcenters/all_exept/' + _id).map((response: Response) => response.json());
  }
  getDocs(_doc: number) {
      return this.http.get('costcenters/doc_list/' + _doc).map((response: Response) => response.json());
    }

  getById(_id: string) {
    console.log('costcenters/' + _id);
    return this.http.get('costcenters/' + _id).map((response: Response) => response.json());
  }

  getfilantype(_id: string) {
    //console.log('costcenters/getfinaltype/' + _id);
    return this.http.get('costcenters/getfinaltype/' + _id).map((response: Response) => response.json());
  }
  checklast(_id: string) {
    //console.log('costcenters/getfinaltype/' + _id);
    return this.http.get('costcenters/checklast/' + _id).map((response: Response) => response.json());
  }

  getTree(_id:string) {
    return this.http.get('costcenters/tree/' + _id).toPromise().then(res => <TreeNode[]> res.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('costcenters/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('costcenters/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(costcenters: Costcenters) {
    return this.http.post('costcenters', costcenters).map((response: Response) => response.json());
  }

  update(costcenters: Costcenters) {
    return this.http.put('costcenters/' + costcenters.id, costcenters).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('costcenters/' + _id).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/costcenters/costcenters.service.ts